$(document).ready(function () {
    let _token = $('meta[name="csrf-token"]').attr('content')
    $("#table-campigns tbody").on('click', '.add-articles-to-campaign', function (e) {
        let table2 = $("#table-campaign-articles").DataTable();
        table2.destroy()
        let description = $(this).data('description')
        let uuid = $(this).data('uuid')
        $(".modal-title-articles").html('Agregar artículos - ' + description)
        $("#modal-campaign-articles").modal('show')
        $("#item-uuid").val(uuid)

        table(uuid, description)
    });


    function table(uuid, description) {
        $("#table-campaign-articles").DataTable({
            proccesing: true,
            serverSide: true,
            language: {
                "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
            },
            responsive: true,
            ajax: 'get-articles-by-campaign/' + uuid,
            columns: [
                {data: 'code_article', name: 'code_article'},
                {data: 'detail_article.nombre', name: 'detail_article.nombre'},

            ],
            "columnDefs": [{
                "targets": 2,
                "data": "download_link",
                "render": function (data, type, row, meta) {
                    console.log(row)
                    return '<button data-toggle="tooltip" data-placement="top" title="Eliminar articulo." class="btn btn-danger ' +
                        'delete-article-in-campaign m-1 btn-sm"' +
                        'data-code-article ="' + row.code_article + ' "><i class="fa-solid fa-trash-can"></i></button> '
                }
            }]
        });
        $('#table-campaign-articles').on('preXhr.dt', function (e, settings, data) {
            togglePreloader()
        });
        $('#table-campaign-articles').on('xhr.dt', function (e, settings, json, xhr) {
            togglePreloader()
        });
    }


    let debounceTimer;

    $("#search_by_code").keyup(function () {
        clearTimeout(debounceTimer); // Limpiar el temporizador existente si existe
        let item_code = $("#search_by_code").val();
        debounceTimer = setTimeout(function() {
            sendRequestCode(item_code);
        }, 1000);
    });

    function sendRequestCode(item_code){
        console.log("Enviado");
        $.post("search_code", {name: item_code, _token: _token})
            .done(function (response) {
                listArticle(response, 'articles');
            });
    }

    $("#search_by_description").keyup(function () {
        clearTimeout(debounceTimer); // Limpiar el temporizador existente si existe
        let item_name = $("#search_by_description").val()
        debounceTimer = setTimeout(function() {
            sendRequest(item_name);
        }, 1000);
    });


    function sendRequest(item_name) {
        $.post("search_name", {name: item_name, _token: _token})
            .done(function (response) {
                listArticle(response, 'articles-name');
            });
    }

    $("#add-article").on('click', function (e){
        e.preventDefault()
        let item_code = $("#search_by_code").val()
        let uuid = $("#item-uuid").val()
        let data = new FormData()
        data.append('itemCode', item_code)
        data.append('uuid', uuid)
        sendData('add-article',data)

    })

    $(document).on('click', ".select-item", function (e) {
        e.preventDefault();
        $("#search_by_code").val($(this).attr("data-code"));
        $("#search_by_description").val($(this).attr("data-name"));
        $(".articles").hide();
        $(".articles").html("");

    })

    $("#table-campaign-articles tbody").on('click','.delete-article-in-campaign', function (e){
        e.preventDefault()
        let data = new FormData()
        data.append('uuid',$("#item-uuid").val())
        data.append('code-article',$(this).data('code-article'))

        Swal.fire({
            title: "¿ Esta seguro de eliminar el articulo ?",
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: "Sí, eliminar",
            cancelButtonText: "Cancelar",
            customClass: {
                confirmButton: 'laproveedora_btn'
            }
        })
            .then(resultado => {
                if (resultado.value) {
                    sendData('delete-article',data)
                }
            });
    })


    function listArticle(data, ele) {
        $("#" + ele).show();
        $("#" + ele).html("");
        $.each(data, function (key, value) {
            var item = '<a href="#" ' +
                'data-id="' + data[key].id + '" data-code="' + data[key].itemcode + '" ' +
                'data-name="' + data[key].nombre + '" ' +
                'class="list-group-item select-item">' + data[key].itemcode + " - " + data[key].nombre + "-" + data[key].ean + '</a>';
            $("#" + ele).append(item);
        });
    }

    $("#form-add-by-lot").on('submit', function (e){
        e.preventDefault()
        console.log("asd")
        let uuid = $("#item-uuid").val()
        let data = new FormData(this)
        data.append('uuid',uuid)
        sendData('upload-file',data)
    })


    function sendData(route,data)
    {
        togglePreloader()
        $.ajax({
            url: route, type: "post", data: data, processData: false, contentType: false, headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }, success: function (response) {
                togglePreloader()
                if (response.type =="error") {
                    alertError(response.msg)
                }else{
                    $("#search_by_code").val("")
                    $("#search_by_description").val("")
                    $("#table-campaign-articles").DataTable().ajax.reload()
                    alertSuccess(response.msg)
                }


            }, error: function (errors, xhr, status,) {
                togglePreloader()
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).addClass('is-invalid')
                    $(".item-error-" + index).text(value);
                });
            }
        })
    }


})
